import React, { Component } from 'react';
import GamePage from '../../components/GamePage';
import STableGames from 'shared/screens/TableGames';
import Utils from 'shared/utils';
import audio from 'shared/utils/audio';
import { GameListWrapper } from '../Home/styledComponents';
import { GAME_TRIGGERS } from 'shared/constants';

export default class TableGames extends Component {
  handleNextClick = () => {
    audio.onClick();
    this.slider.current.slickNext();
  };

  handlePrevClick = () => {
    audio.onClick();
    this.slider.current.slickPrev();
  };

  handleFirstClick = () => {
    audio.onClick();
    this.slider.current.slickGoTo(0);
  };

  handleLastClick = pagesCount => {
    audio.onClick();
    this.slider.current.slickGoTo(pagesCount);
  };

  render() {
    return (
      <STableGames
        navigation={this.props.navigation}
        {...this.props}
        render={args => {
          const { pagedGames, lobbyPromotions } = args;
          const hasPromotions = !Utils.isEmpty(lobbyPromotions);
          const hasGames = !Utils.isEmpty(pagedGames);

          return (
            <div className="roomPage">
              <div className="roomContent">
                {hasGames && (
                  <GameListWrapper banner={hasPromotions}>
                    <div className={'GameListContainer'}>
                      <GamePage
                        {...args}
                        navigation={this.props.navigation}
                        hasPromotions={hasPromotions}
                        trigger={GAME_TRIGGERS.TABLE}
                      />
                    </div>
                  </GameListWrapper>
                )}
              </div>
            </div>
          );
        }}
      />
    );
  }
}

